export const colors = {
  primary: '#032541',
  primaryLight: '#EFF3FE',
  secondary: '#03b3e4',
  secondaryLight: '#90cfa2',
  black: '#000000',
  white: '#ffffff',
  gray: '#767676',
  grayDark: '#D0D0D0',
  star: '#ffd700',
  seagreenPrimay: '#20d5a9',
  seagreenSecondary: '#bdfdcf',
  redPrimary: '#d93b62',
  redSecondary: '#fdc271',
};
